import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    validateSchemaFields
} from 'lib/formUtils';
import {
    Box,
    CardContent,
    TextField,
    Typography
} from '@material-ui/core';
import api from 'services/api';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import FormActions from 'views/Components/FormActions';
import { getCodUsuarioRegistrou } from 'lib/functions';
import FormStatusSwitch from 'views/Components/FormStatusSwitch';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class MarcaVeiculoForm extends Component {
    state = {
        isNewRecord: false,
        isView: false,
        marcaveiculo: {
            codmarcaveiculo: '',
            descmarcaveiculo: '',
            inativo: ANAO
        },
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            descmarcaveiculo: {
                presence: { allowEmpty: false, message: 'Descrição da marca obrigatória' },
                length: { maximum: 100 },
                type: 'string'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    marcaveiculo: this.getMarcaVeiculoDefault()
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadMarcaVeiculo(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar marca de veículo:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar marca de veículo!'
                )
            );
        }
    };

    /* Retorna a marca de veículo padrão */
    getMarcaVeiculoDefault = () => ({
        codmarcaveiculo: '',
        descmarcaveiculo: '',
        inativo: ANAO
    });

    /* Carrega a marca de veículo */
    loadMarcaVeiculo = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/marcaveiculo/${id}`);
        const registro = getRecordFromResponse(response);

        if (!registro) {
            this.handleOpenAlert('Marca de veículo não encontrada!');

            history.push('/frotas/marcaveiculo');

            return;
        }

        this.setState({
            marcaveiculo: {
                codmarcaveiculo: registro.codmarcaveiculo || '',
                descmarcaveiculo: registro.descmarcaveiculo || '',
                inativo: registro.inativo || ANAO
            },
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        const adjustedValue = type === 'checkbox' ? (checked ? ANAO : ASIM) : value.toUpperCase();

        this.setState(prevState => ({
            marcaveiculo: {
                ...prevState.marcaveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de marca de veículo */
    getPayloadMarcaVeiculo = () => {
        const { marcaveiculo } = this.state;
        const codusuarioregistrou = getCodUsuarioRegistrou();
        const usuarioregistrou = sessionStorage.getItem('usuario') || sessionStorage.getItem('user');

        if (!codusuarioregistrou && !usuarioregistrou) {
            throw new Error('Usuário não encontrado!');
        }

        return {
            descmarcaveiculo: marcaveiculo.descmarcaveiculo || '',
            inativo: marcaveiculo.inativo || ANAO,
            codusuarioregistrou,
            usuarioregistrou
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { marcaveiculo, isNewRecord } = this.state;
        const { history, loadMarcaVeiculo } = this.props;

        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const payload = this.getPayloadMarcaVeiculo();

            if (isNewRecord) {
                await api.post('/marcaveiculo', payload);
            } else {
                await api.put(`/marcaveiculo/${marcaveiculo.codmarcaveiculo}`, payload);
            }

            if (loadMarcaVeiculo) loadMarcaVeiculo();

            history.push('/frotas/marcaveiculo');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/marcaveiculo');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { marcaveiculo, schema } = this.state;

        return validateSchemaFields(
            marcaveiculo,
            schema,
            ['descmarcaveiculo']
        );
    };

    render() {
        const {
            errors,
            isView,
            marcaveiculo,
            messageAlert,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Marca de veículos {marcaveiculo.codmarcaveiculo}
                        </Typography>

                        <FormStatusSwitch
                            checked={marcaveiculo.inativo !== ASIM}
                            name="inativo"
                            onChange={this.onChange}
                            disabled={isView}
                        />
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Descrição"
                            name="descmarcaveiculo"
                            value={marcaveiculo.descmarcaveiculo || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.descmarcaveiculo || ''}
                            error={!!errors.descmarcaveiculo}
                            disabled={isView}
                            inputProps={{ maxLength: 100 }}
                            fullWidth
                        />
                    </Box>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default MarcaVeiculoForm;